export default __webpack_public_path__ + "static/media/session.53fde16e.svg";